module.exports = __webpack_public_path__ + "static/media/A-112.7bd9fa97.webp";